import {Divider, Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {UnitCard} from 'presentation/modules/booking/shared/ui/components/UnitCard';

import React from 'react';
import {useExamAdvanceUnits} from './hooks/useExamAdvanceUnits';
import {ExamAdvanceUnitsProps} from './types';

export function ExamAdvanceUnits({
	advanceUnits,
	handleNextStep,
	hideDivider,
}: ExamAdvanceUnitsProps) {
	const {isMobile, query, specialtyName, title, handleSelectCard} = useExamAdvanceUnits({
		advanceUnits,
		handleNextStep,
	});

	return (
		<Stack gap={1}>
			<Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
				{title}
			</Typography>

			<Grid container spacing={2}>
				{advanceUnits?.map(unit => {
					return (
						<Grid
							key={`${unit.name}-${unit.formattedAddress}`}
							size={{xs: isMobile ? 12 : 6}}>
							<UnitCard
								query={query}
								isNotSelf={false}
								onClick={() =>
									handleSelectCard({
										code: unit?.code,
										address: unit?.formattedAddress,
										name: unit?.name,
									})
								}
								unitName={unit?.name}
								address={unit?.formattedAddress}
								nmBairroOrigem={unit?.nmBairroOrigem}
								isTelemedicine={false}
								distanceReference={unit?.distance}
								specialtyName={specialtyName}
								isAdvanceUnit
								showDistanceReference
							/>
						</Grid>
					);
				})}
			</Grid>

			{hideDivider ? null : <Divider sx={{mt: 2}} />}
		</Stack>
	);
}
